





























































import { defineComponent, ref, watch, computed } from '@vue/composition-api';
import Clickoutside from 'byted-vui/src/utils/clickoutside';
import SelectEmpty from './select-empty.vue';
import SelectError from './select-error.vue';

const name = 'ttam-select-panel';
export default defineComponent({
  name,
  directives: { Clickoutside },
  components: { SelectEmpty, SelectError },
  props: {
    value: Boolean,
    empty: {
      type: Boolean,
      default: false,
    },
    emptyText: {
      type: String,
      default: '',
    },
    error: {
      type: Boolean,
      default: false,
    },
    errorText: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    panelWidth: {
      type: String,
      default: '480',
    },
    openDelay: {
      type: Number,
      default: 0,
    },
    revertPlacement: {
      type: Boolean,
      default: false,
    },
    referenceHeight: {
      type: Number,
      default: 34,
    },
    infiniteScroll: Boolean,
    infiniteScrollLoading: Boolean,
  },
  setup(props, { emit }) {
    const curVisible = ref(props.value);
    const delayTime = ref(props.openDelay);
    const showScrollDom = ref(true);

    const panelWidth = ref(props.panelWidth);
    const referenceHeight = ref(props.referenceHeight);
    const dropdownStyle = computed(() => {
      if (props.revertPlacement) {
        return {
          width: `${panelWidth.value}px`,
          bottom: `${referenceHeight.value}px`,
        };
      }

      return {
        width: `${panelWidth.value}px`,
      };
    });

    if (delayTime.value) {
      showScrollDom.value = false;
    }

    watch(
      () => props.value,
      val => {
        curVisible.value = val;
        if (val) {
          emit('show');
          if (delayTime.value) {
            showScrollDom.value = false;
            setTimeout(() => {
              showScrollDom.value = true;
            }, delayTime.value);
          }
        }
      },
    );

    function handleClose() {
      // 解决一些 dom 事件处理的时机问题
      setTimeout(() => {
        curVisible.value = false;
        if (delayTime.value) {
          showScrollDom.value = false;
        }
        emit('input', curVisible.value);
      });
    }

    function toggleModal() {
      if (props.disabled) {
        return;
      }
      curVisible.value = !curVisible.value;
      emit('input', curVisible.value);
    }

    return {
      name,
      curVisible,
      handleClose,
      toggleModal,
      showScrollDom,
      dropdownStyle,
    };
  },
});
